/* Fernuni Planer – Artikel-Enhancements
   Baut einen ausklappbaren TOC aus h2/h3 im Article-Content.
   - Default offen auf Desktop, zu auf Mobile.
   - Ersetzt vorhandene .fp-toc oder .toc-Elemente, sonst einfügen vor dem ersten h2.
   - Wenn weniger als 2 h2: kein TOC.
*/
(function () {
  'use strict';

  function slugify(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function buildToc() {
    var content = document.querySelector('.article-template__content');
    if (!content) return;

    var headings = content.querySelectorAll('h2, h3');
    var h2List = content.querySelectorAll('h2');
    if (h2List.length < 2) return;

    var seen = {};
    var items = [];
    headings.forEach(function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      if (!h.id) {
        var base = slugify(text) || 'abschnitt';
        var slug = base;
        var i = 2;
        while (seen[slug] || document.getElementById(slug)) {
          slug = base + '-' + i++;
        }
        h.id = slug;
        seen[slug] = true;
      } else {
        seen[h.id] = true;
      }
      items.push({ level: h.tagName === 'H2' ? 2 : 3, id: h.id, text: text });
    });

    if (!items.length) return;

    var details = document.createElement('details');
    details.className = 'fp-toc';
    details.open = false;

    var summary = document.createElement('summary');
    summary.className = 'fp-toc__summary';
    summary.innerHTML =
      '<span class="fp-toc__title">' +
        '<svg class="fp-toc__title-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M4 6h16M4 12h16M4 18h10"/>' +
        '</svg>' +
        'Inhalt' +
      '</span>' +
      '<svg class="fp-toc__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M6 9l6 6 6-6"/>' +
      '</svg>';

    var ol = document.createElement('ol');
    ol.className = 'fp-toc__list';

    items.forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'fp-toc__item' + (it.level === 3 ? ' fp-toc__item--lvl3' : '');
      var a = document.createElement('a');
      a.className = 'fp-toc__link';
      a.href = '#' + it.id;
      a.textContent = it.text;
      li.appendChild(a);
      ol.appendChild(li);
    });

    details.appendChild(summary);
    details.appendChild(ol);

    var oldToc = content.querySelector('.fp-toc, .toc');
    if (oldToc) {
      oldToc.replaceWith(details);
    } else {
      var firstH2 = content.querySelector('h2');
      if (firstH2 && firstH2.parentNode === content) {
        content.insertBefore(details, firstH2);
      } else {
        content.insertBefore(details, content.firstChild);
      }
    }

    summary.addEventListener('click', function (e) {
      var below750 = window.matchMedia('(max-width: 749px)').matches;
      if (below750) {
        try { details.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (_) {}
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }
})();
